import Accordion from './accordion.vue';
import Icon from './icon.vue';
import UiModal from './modal.vue';

export default {
    Accordion,
    Icon,
    UiModal,
};
